import React, { useRef } from 'react';
import { useAccion, api } from '../estado.jsx';
import { urlFoto } from '../api.js';

/**
 * Galería de fotos de un centro.
 *
 * La usan dos vistas con permisos distintos: "Mi sede", donde el centro
 * gestiona las suyas, y la ficha de Aleph, que opera sobre cualquiera. La
 * diferencia es solo el `sedeId`: cuando no se pasa, el backend toma la sede
 * del token. Aleph tiene que indicarlo porque no "tiene" una sede propia.
 */
export function Fotos({ fotos, sedeId }) {
  const { ejecutar, enCurso, error, setError } = useAccion();
  const entrada = useRef(null);

  const elegir = (e) => {
    const fichero = e.target.files?.[0];
    if (!fichero) return;
    // El backend comprueba los bytes de verdad; esto solo evita el viaje
    // cuando está claro de antemano que no vale.
    if (!fichero.type.startsWith('image/')) {
      setError('Elige una imagen.');
      return;
    }
    ejecutar(() => api.subirFoto(fichero, sedeId), () => { entrada.current.value = ''; });
  };

  return (
    <>
      <h2 className="section-h">Fotos del local</h2>
      <p className="section-note">
        Se guardan en el servidor y la base de datos solo conserva su dirección.
        JPG, PNG o WebP, hasta 8 MB. La primera es la que se ve en el listado de centros.
      </p>
      <div className="photo-grid">
        {fotos.map((f) => (
          <div key={f.id} className="photo">
            <img src={urlFoto(f.url)} alt="" />
            <button className="rm" disabled={enCurso}
                    onClick={() => ejecutar(() => api.quitarFoto(f.id))}>×</button>
          </div>
        ))}
        <button className="photo-add" disabled={enCurso}
                onClick={() => entrada.current?.click()}>
          <svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14" /></svg>
          {enCurso ? 'Subiendo…' : 'Subir foto'}
        </button>
      </div>
      <input ref={entrada} type="file" accept="image/jpeg,image/png,image/webp"
             style={{ display: 'none' }} onChange={elegir} />
      <div className="inline-err show">{error}</div>
    </>
  );
}
